import API_CONFIG from "../../config/api";

export function obraLogoPublicUrl(logoName) {
    if (logoName == null || String(logoName).trim() === "") {
        return null;
    }
    const base = API_CONFIG.baseURL.replace(/\/$/, "");
    return `${base}/Painel/uploads/uploads/controle-medicao/${encodeURIComponent(String(logoName).trim())}`;
}
